import ReviewSuccessModal from './ReviewSuccessModal';

export default ReviewSuccessModal;
